import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './firebase';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRoute from './components/ProtectedRoute';
import './firebase';
import { UserProvider } from './contexts/UserContext';
import PreviousTranscation from './pages/PreviousTranscation';
import Layout from './components/Layout';

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<PrivateRoute />}>
              <Route index element={<Home />} />
              <Route
                path="/transactions-history"
                element={<PreviousTranscation />}
              />
            </Route>
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
